export default __webpack_public_path__ + "static/media/Platform Suite_Logo_White_LG.67839786.png";